import { type RefObject, useRef, useState } from 'react';

import { captureImageFrame } from '../helper/captureImageFrame';

type UseGifPlaybackReturn = {
    imageContainerRef: RefObject<HTMLDivElement | null>;
    isPlaying: boolean;
    pausedSrc: string | null;
    togglePlayback: () => void;
};

const useGifPlayback = (): UseGifPlaybackReturn => {
    const imageContainerRef = useRef<HTMLDivElement>(null);
    const [isPlaying, setIsPlaying] = useState(true);
    const [pausedSrc, setPausedSrc] = useState<string | null>(null);

    const togglePlayback = (): void => {
        if (isPlaying) {
            const image = imageContainerRef.current?.querySelector('img');
            if (image) {
                const frame = captureImageFrame(image);
                if (frame) {
                    setPausedSrc(frame);
                }
            }

            setIsPlaying(false);
            return;
        }

        setPausedSrc(null);
        setIsPlaying(true);
    };

    return { imageContainerRef, isPlaying, pausedSrc, togglePlayback };
};

export { useGifPlayback };
